import { render, staticRenderFns } from "./GarbageDisposal.vue?vue&type=template&id=367701f6&"
import script from "./GarbageDisposal.vue?vue&type=script&lang=js&"
export * from "./GarbageDisposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports